import { getIsInWishList, WishlistItem } from 'features/shopping-list';
import { REMOVE_FROM_SHOPPING_LIST_REQUEST } from 'features/shopping-list/ducks/shopping-list';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { ActionType, createAction } from 'typesafe-actions';
import {
  CompareCategory,
  selectCompareCategory,
  selectProductBrand,
  selectProductPriceCategory,
} from 'features/product-info';
import {
  selectProductBelong,
  selectProductDiscount,
  selectProductName,
  selectProductPrice,
  selectProductPricePrevious,
} from './selectors';

/**
 * Cобытие должно срабатывать при удалении товара из списка покупок.
 *
 * @see https://docs.google.com/document/d/1Y_vg_aaS7COYvoc4daxezKkWJUiH2Wn-hLAJ9D2ziac/edit#
 */
export const gaRemoveFromShoppingList = createAction('GA:removeFromShoppingList')<{
  elementType: 'button';
  elementBlock: 'productDetail'; // блок, в котором расположен элемент
  elementName: 'shoppingList';
  productTag?: string | null;
  productName: string; // название товара
  productId: string; // артикул товара
  productPrice: string; // стоимость единицы товара
  productBelong: 'LeroyMerlin' | 'LeroyMerlinMarketplace' | 'Longtail'; // принадлежность товара: LeroyMerlinMarketplace - для товаров Маркетплейс, Longtail - для товаров longtail, LeroyMerlin - для товаров Леруа Мерлен
  productPrevPrice: string | null;
  productDiscount: number | null;
  brand?: string | null;
  category?: string;
}>();

export function* putGaRemoveFromShoppingList(productId: WishlistItem['code']) {
  yield put(
    gaRemoveFromShoppingList({
      elementType: 'button',
      elementBlock: 'productDetail',
      elementName: 'shoppingList',
      productName: yield call(selectProductName),
      productTag: yield call(selectProductPriceCategory),
      productId,
      brand: (yield call(selectProductBrand)) as string,
      category: ((yield call(selectCompareCategory)) as CompareCategory)?.name || '',
      productPrice: yield call(selectProductPrice),
      productBelong: yield call(selectProductBelong),
      productPrevPrice: yield call(selectProductPricePrevious),
      productDiscount: yield call(selectProductDiscount),
    }),
  );
}

export function* runRemoveFromShoppingListDetector() {
  yield takeEvery(
    REMOVE_FROM_SHOPPING_LIST_REQUEST,
    function* handle({ payload }: ActionType<typeof REMOVE_FROM_SHOPPING_LIST_REQUEST>) {
      const isInWishList: boolean = yield select(getIsInWishList, payload);

      if (isInWishList) {
        yield putGaRemoveFromShoppingList(payload);
      }
    },
  );
}
